<template>
    <el-dialog
        :title="isForm ? (formId ? '编辑' : '添加任务') : '查看'"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="任务名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入任务名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="任务分组" prop="task_type">
                        <el-select v-if="isForm" v-model="formData.task_type" placeholder="请选择任务分组">
                            <el-option
                                v-for="item in taskTtypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <span v-else>{{ formData.task_type }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开始日期" prop="begin_time">
                        <el-date-picker
                            v-if="isForm"
                            v-model="formData.begin_time"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            type="date"
                            placeholder="选择开始日期"
                            :disabled-date="disabledBeginDate"
                        />
                        <span v-else>{{ formData.begin_time }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="结束日期" prop="stop_time">
                        <el-date-picker
                            v-if="isForm"
                            v-model="formData.stop_time"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            type="date"
                            placeholder="选择结束日期"
                            :disabled-date="disabledStopDate"
                        />
                        <span v-else>{{ formData.stop_time }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="重复周期" prop="period">
                <el-select
                    v-if="isForm"
                    v-model="formData.period"
                    clearable
                    filterable
                    placeholder="必填"
                    @change="handleChangePeriod"
                >
                    <el-option v-for="item in periodTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <div v-else>{{ formData.period }}</div>
            </el-form-item>
            <el-form-item v-if="formData.period == 3" class="formItemTitle" label=" " prop="period_lists">
                <el-checkbox-group v-model="formData.period_lists">
                    <el-checkbox v-for="week in weekArr" :label="week.value" :key="week.label">{{ week.label }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="formData.period == 4" class="formItemTitle" label=" " prop="period_lists">
                <el-select
                    v-if="isForm"
                    v-model="formData.period_lists"
                    clearable
                    multiple
                    collapse-tags
                    placeholder="请选择某天"
                >
                    <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="formItemTitle" label="选择时间">
                <el-time-picker
                    v-model="formData.start_time"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss"
                    placeholder="选择时间"
                ></el-time-picker>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">正常</el-radio>
                    <el-radio :value="0">停用</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addTask, getTaskDetail, putTask } from '@/api/job.js'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    },
    taskTtypeOptions: {
        type: Array
    },
    periodTypes: {
        type: Array
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

const weekArr = [
    { label: '周一', value: 1 },
    { label: '周二', value: 2 },
    { label: '周三', value: 3 },
    { label: '周四', value: 4 },
    { label: '周五', value: 5 },
    { label: '周六', value: 6 },
    { label: '周日', value: 7 }
]

// 表单源
const formData = ref({
    name: '',
    task_type: '',
    begin_time: '',
    stop_time: '',
    period: '',
    period_lists: [],
    start_time: '',
    list_order: 0,
    status: 1
})
// 验证规则
// const validatePeriod = (rule, value, callback) => {
//     if (value.length) {
//         callback()
//     } else {
//         if (formData.value.period === 3) {
//             callback(new Error('请选择重复周!'))
//         } else if (formData.value.period === 4) {
//             callback(new Error('请选择重复天!'))
//         } else {
//             callback()
//         }
//     }
// }

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入任务名称'
        }
    ],
    task_type: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择任务分组'
        }
    ],
    period: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择重复周期'
        }
    ]
    // period_lists: [
    //     { validator: validatePeriod, trigger: 'blur' }
    // ]
})

const submitLoading = ref(false)
const formRef = ref(null)
const disabledBeginDate = (time) => {
    if (formData.value.stop_time) {
        return time.getTime() > new Date(formData.value.stop_time).getTime() || time.getTime() < Date.now()
    } else {
        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
    }
}
const disabledStopDate = (time) => {
    if (formData.value.begin_time) {
        return time.getTime() < new Date(formData.value.begin_time).getTime()
    } else {
        return time.getTime() < Date.now()
    }
}
const handleChangePeriod = () => {
    formData.value.period_lists = []
}
/**
 * 关闭
 */
const closed = () => {
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputTask()
    } else {
        await doaddTask()
    }
}

// 修改定时任务
const doputTask = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        // submitLoading.value = true
        await putTask(formData.value)
        // 定时任务修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加定时任务
const doaddTask = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        formData.value.period_lists = formData.value.period_lists.sort()
        await addTask(formData.value)
        // 定时任务添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取定时任务详情
const getTaskDetailFun = async () => {
    formData.value = await getTaskDetail(props.formId)
    formData.value.task_type = formData.value.task_type.toString()
    formData.value.period = formData.value.period.toString()
    formData.value.start_time = dayjs(formData.value.start_time).format('HH:mm:ss')
}

// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getTaskDetailFun()
        } else {
            formData.value = {
                name: '',
                task_type: '',
                begin_time: '',
                stop_time: '',
                period: '',
                period_lists: [],
                start_time: '',
                list_order: 0,
                status: 1
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
